import { render, staticRenderFns } from "./ProjectsItemParticipantsComponent.vue?vue&type=template&id=3472a376&scoped=true&"
import script from "./ProjectsItemParticipantsComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsItemParticipantsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsItemParticipantsComponent.vue?vue&type=style&index=0&id=3472a376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472a376",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAvatar,VBtn,VChip,VCol,VDialog,VIcon,VImg,VRow,VSheet,VSwitch})
